var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 9.759a.9.9 0 0 1 .9.9v.007a.9.9 0 0 1-1.8 0v-.007a.9.9 0 0 1 .9-.9M8 4.583a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .583a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8 .583m0 1.5a5.918 5.918 0 0 0 0 11.833A5.916 5.916 0 0 0 8 2.083",
    clipRule: "evenodd"
  })));
};
export default Svg16;